import { Seo } from "@/components/Seo";

export default function ImpressumPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Seo title="Impressum | Rechnerkiste" description="Impressum der Rechnerkiste." />
      <h1 className="text-3xl font-semibold">Impressum</h1>
      <div className="mt-6 space-y-4 text-muted-foreground leading-relaxed">
        <h2 className="text-lg font-semibold text-foreground">Angaben gemäß § 5 DDG</h2>
        <p>Adrian Goldner<br/>Keplerstr. 25<br/>60318 Frankfurt am Main<br/>Deutschland</p>

        <h2 className="text-lg font-semibold text-foreground">Kontakt</h2>
        <p>Telefon: 0176 22956705<br/>E-Mail: info@adriangoldner.com</p>

        <h2 className="text-lg font-semibold text-foreground">Redaktionell verantwortlich</h2>
        <p>Adrian Goldner<br/>Keplerstr. 25, 60318 Frankfurt am Main</p>

        <h2 className="text-lg font-semibold text-foreground">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
        <p>Ich bin nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      </div>
    </div>
  );
}
